import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepComponent } from "./step/step.component";

export interface Step {
  title: string;
  isActive: boolean;
}

@Component({
  selector: 'ui-stepper',
  standalone: true,
  imports: [CommonModule, StepComponent],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  /**
   * The steps to be displayed in the stepper.
   * Each step should have a title and an active state.
   * The active state determines whether the step is highlighted or not.
   * Displayed in the order they are provided.
   * @example
   * steps = [
   *   { title: 'Step 1', isActive: true },
   *   { title: 'Step 2', isActive: false },
   *   { title: 'Step 3', isActive: false },
   */
  @Input() steps: Step[] = [];

  getColumnSize(numberOfSteps: number): string {
    if(numberOfSteps >= 6) {
      return 'col-md-2 col-sm-4 col-xs-2 col-2';
    } else {
      const size = Math.floor(12/numberOfSteps);
      return `col-md-${size} col-sm-${size} col-xs-2 col-4`;
    }
  }
}